import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReviewsWall() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/reviews/published`).then((r) => {
      setReviews(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-background grain px-6 sm:px-10 py-16">
      <div className="max-w-5xl mx-auto">
        <header className="mb-12 text-center">
          <div className="mb-3">
            <span className="text-xs tracking-[0.3em] uppercase text-zinc-300">Jeff Harrington</span>
          </div>
          <h1 className="font-display uppercase text-4xl sm:text-5xl tracking-tighter text-[#F5F5F0]">
            Student Reviews
          </h1>
          <p className="text-zinc-400 mt-3 text-sm">
            Saxophone &amp; Jazz Improvisation Lessons — Online &amp; In-Person
          </p>
        </header>

        {loading ? null : reviews.length === 0 ? (
          <p className="text-zinc-500 text-center italic" data-testid="wall-empty">Reviews coming soon.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="reviews-wall-grid">
            {reviews.map((r) => (
              <div key={r.id} className="border border-border bg-card rounded-lg p-6 fade-up" data-testid={`wall-review-${r.id}`}>
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} size={16} className={i <= r.rating ? "text-[#D4AF37]" : "text-zinc-700"} fill={i <= r.rating ? "#D4AF37" : "none"} />
                  ))}
                </div>
                <p className="text-zinc-300 text-sm leading-relaxed italic mb-5">
                  “{r.feedback || r.experience}”
                </p>
                <p className="text-[#F5F5F0] font-semibold text-sm">{r.name}</p>
                {r.lesson_type && (
                  <p className="text-zinc-500 text-xs mt-1 uppercase tracking-wider">{r.lesson_type} Lessons</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
